import styled from '@emotion/styled';
import { fontSize } from '@styles/globalStyles';

const Banner = styled.section`
  background-color: #f7f7f8;
  width: 100;
  padding: 72px;
  text-align: center;
  border-top: 1px solid #272727;
  a {
    margin-top: 48px;
  }
`;

export default Banner;
